import { setContext, setUser } from '@sentry/react';
import LogRocket from 'logrocket';

interface IIdentifiedUser {
	id: string;
	name: string;
	email: string;
}

const identifyUser = (user: IIdentifiedUser) => {
	// Identify user in log rocket
	LogRocket.identify(user.id, {
		name: user.name,
		email: user.email,
	});

	// Identify user in sentry
	setUser({
		id: user.id,
		email: user.email,
		username: user.name,
	});
	setContext('user', user);
};

export default identifyUser;
